import { render, staticRenderFns } from "./view-right.vue?vue&type=template&id=cf1f7886&scoped=true"
import script from "./view-right.vue?vue&type=script&lang=js"
export * from "./view-right.vue?vue&type=script&lang=js"
import style0 from "./view-right.vue?vue&type=style&index=0&id=cf1f7886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1f7886",
  null
  
)

export default component.exports